import { render, staticRenderFns } from "./ConferenceIcon.vue?vue&type=template&id=01e23132"
import script from "./ConferenceIcon.vue?vue&type=script&lang=js"
export * from "./ConferenceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports